<template>
    <div id="first">
        <div class="map text-center">
            <img :src="MapImage" class="MapImage" alt="MapImage">
            <p class="normadic red">Normadic by nature</p>
            <p class="welcome">Welcome to <span class="red">Mongolia</span></p>
        </div>
        <div class="description">
            <p>
                You have probably heard of Mongolia through the famous tales of Genghis Khan, history books and Hollywood films. Very few have actually witnessed the raw beauty, culture and heritage of the country. When people talk about the road less travelled, there is no better place than Mongolia as it is one of the world’s least explored travel destinations. 
            </p>
            <p>
                Imagine vast lands as far as the eyes can see, deterred only by tall mountains and trees. Cobalt blue skies hover over scenic landscape encompassing rivers, lakes, forests and deserts. Here, nature is only rivalled by the traditional hospitality of its people, their culture and heritage.
            </p>
            <p>
                Come and experience the culture and heritage of the last surviving nomadic societies. Adventure awaits you…
            </p>
        </div>
        <IG />
        <div class="arrow text-right">
            <router-link to="/about-mongolia">
                <img :src="arrowRight" alt="arrowRight">
            </router-link>
            
        </div>
    </div>
</template>

<script>
import MapImage from '../../assets/img/map-first.png'
import arrowRight from '../../assets/img/arrow-right.png'
import IG from '@/components/FirstIG'
export default {
    name: 'first',
    components : {
        IG
    },
    data() {
        return {
            MapImage : MapImage,
            arrowRight : arrowRight
        }
    }
}
</script>

<style lang="scss" scoped>
    #first {
        padding: 52px 0px;

        .map {
            padding: 30px 22px 0px;

            .normadic {
                padding: 20px 0 0;
                margin-bottom: 15px;
            }

            .welcome {
                color: #2C2C2C;
                font-size: 25px;
                font-weight: bold;
                padding: 0;
                margin-bottom: 10px;
            }
        }

        .description {
            padding: 30px 22px 0px;
        }

        .red {
            color: #E13036;
        }

        .arrow {
            padding: 50px 15px 0;
        }
    }
</style>


